export default "__VITE_ASSET__DoQXXxzz__"